export const ContentWidget = require("./content-widget.js").default;
export const ContentPiece = require("./content-piece.js").default;
export const Day = require("./day.js").default;
export const SmartInput = require("./smart-input.js").default;
export const Sidebar = require("./sidebar.js").default;

export const { UploadSyllabus, SyllabusDetails } = require("./modal.js");
